import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VisorComponent } from './components/visor/visor.component';


// MUDULO INACTIVO  - SE REDIRIJE A UFLOW
// This module defines the routing for the Visor feature of the application.
const routes: Routes = [
  { path: 'visor', component: VisorComponent },
  { path: '', redirectTo: 'uflow', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VisorRoutingModule {}
